import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => (
  <section className="bg-[#0F0F0F] py-24 md:py-32" data-testid="final-cta-section">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white leading-[1.1]">
        Ready to Run Your First Campaign?
      </h2>
      <p className="mt-5 text-base md:text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed">
        Join brands and agencies already using Vyvre to execute influencer campaigns without the chaos.
      </p>
      <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/demo"
          className="w-full sm:w-auto px-7 py-3 rounded-full text-sm font-semibold bg-[#FF451A] text-white hover:bg-[#E63E17] transition-colors shadow-[0_6px_24px_rgba(255,69,26,0.35)] inline-flex items-center justify-center gap-2"
          data-testid="final-cta-request-demo"
        >
          Request Demo <ArrowRight size={14} />
        </Link>
        <Link
          to="/login"
          className="w-full sm:w-auto px-7 py-3 rounded-full text-sm font-semibold border border-white/25 text-white hover:bg-white/5 transition-colors inline-flex items-center justify-center"
          data-testid="final-cta-sign-in"
        >
          Sign In
        </Link>
      </div>
    </div>
  </section>
);

export default CTASection;
